import { Component, OnInit } from '@angular/core';
import { PsalterSearchModel } from '../psalter-search/psalter-search.component';
import { PsalterSummary, PsalterService } from '../../services/psalter.service';
import { MatDialog } from '@angular/material/dialog';
import { PsalterEditComponent } from '../psalter-edit/psalter-edit.component';

@Component({
  selector: 'app-psalter',
  templateUrl: './psalter.component.html',
  styleUrls: ['./psalter.component.css']
})
export class PsalterComponent implements OnInit {

  public entities: PsalterSummary[];
  public isLoading = false;
 
  public numberOfRecords = 0;
  public pageNumber = 1;  
  public searchProofed: boolean;
  public searchFilter: string;

  public countTotalProofed: number; 
  public countTotalNotProofed: number; 

  private localStorageKey_numberOfRecords = "grid_numberOfItemsToDisplay_psalter";
  private localStorageKey_searchProofed = "search_psalter_proofed";
 

  constructor(
    public dialog: MatDialog,
    private psalterSvc: PsalterService,
    ) { }

  ngOnInit() {

    this.numberOfRecords = Number(localStorage.getItem(this.localStorageKey_numberOfRecords));
    if (this.numberOfRecords === 0) {
      this.numberOfRecords = 15;
    }
  
    this.searchProofed = this.GetDefaultOption_SearchProofed();
    
  }

  private GetDefaultOption_SearchProofed() : boolean {
    var proofed = localStorage.getItem(this.localStorageKey_searchProofed);
    if (proofed === "false") {
      return false
    } else if (proofed === "true") {
      return true;
    }
    return null;
  }

  public search(e: PsalterSearchModel) {
    console.log("search", e);
    this.getItems(e);
  }

  public edit(e: PsalterSummary) {
    console.log("edit", e); 
    this.openModal(e.Id); 
  }

  public delete(e: PsalterSummary) {
    console.log("delete", e); 

    if (confirm("Are you sure you want to delete this item?")) {
      this.psalterSvc.delete(e.Id).then(s=> {
        this.removeItemFromList(e);
      })
    } 
  }

  public add() {
    console.log("add"); 
    this.openModal(null); 
  }

  public openModal(id: number) {
    var modal = this.dialog.open(PsalterEditComponent);
    modal.componentInstance.setModal(id);

    modal
      .afterClosed()
      .subscribe((savedItem: PsalterSummary)=> { 
        console.log("modal closed", savedItem, this); 

        if (savedItem == undefined) return;

        //add the new item to the array 
        this.updateItemList(savedItem);

        if (savedItem.IsProofed == true) {
          this.openNextInLine(savedItem);
        }
 
      });
  }

  private openNextInLine(existingEntity: PsalterSummary) {
    console.log("openNextInLine", existingEntity);

    var index = this.entities.indexOf(existingEntity);
    console.log(index, this.entities.length, this.entities[index]);

    var nextIndex = index + 1;
    if (nextIndex < this.entities.length) {
      var nextEntity = this.entities[nextIndex];
      this.openModal(nextEntity.Id);
    }

  }

  public getItems(model: PsalterSearchModel) { 
    this.isLoading = true;
    this.psalterSvc.loadEntities(model).then(
      (data) => {
         
        this.entities = data;
    
        this.updateEntities();
        this.isLoading = false;
   
      }
    );
  }
   
private renderPaginationItemStatus(p: any) {
  //console.log("renderPaginationItemStatus", p, this.numberOfRecords ,p.getCurrent());
 
  var currentPage = p.getCurrent();
  var numberOfRecordsInSet = p.getTotalItems();

  var startingRecord = ((currentPage - 1) * this.numberOfRecords) + 1;

  if (currentPage == 1) {
    startingRecord = 1;
  }
   
  var endingRecord = startingRecord + (this.numberOfRecords - 1);
  if (endingRecord > numberOfRecordsInSet) {
    endingRecord = numberOfRecordsInSet;
  };
 
  return startingRecord + " to " + endingRecord; 
}

public changeProofedOption() {
  localStorage.setItem(this.localStorageKey_searchProofed, this.searchProofed + "");
}

public changeNumberOfRecords() {
  localStorage.setItem(this.localStorageKey_numberOfRecords, this.numberOfRecords.toString());
}
 
public updateItemList(item: PsalterSummary) {
  
  if (item == null) return;

    var results = this.entities.filter(s=> { return s.Id == item.Id });
    if (results.length > 0) { 

      var index = this.entities.indexOf(results[0]);
      this.entities[index] = item; 
    }  else {
      this.entities.push(item); 
    }
    
    this.updateEntities();
}


public removeItemFromList(item: PsalterSummary) {
  
  if (item == null) return;

    var results = this.entities.filter(s=> { return s.Id == item.Id });
    if (results.length > 0) {  
      var index = this.entities.indexOf(results[0]);
      this.entities.splice(index,1); 
    }    

    this.updateEntities();
}

private updateEntities() {

  this.entities.forEach(item => {
     
    var availableSearchTerms: string[] = []; 

    
    // Set search terms for angular 
    availableSearchTerms.push(item.Html); 

    item.AvailableSearchTerms = availableSearchTerms; 


  });

  this.countTotalNotProofed = this.entities.filter(s=> s.IsProofed === false).length;
  this.countTotalProofed = this.entities.filter(s=> s.IsProofed === true).length;
}
 

}
